import React, { useState } from 'react';
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
// import ModalEnd from "./ModalEnd";
//import {number, object, string} from "prop-types";

const Calculation = (props) => {
    let [calculated, setCalculated] = useState({ res: '---', res1: '---', res2: '---', res3: '---', res4: '---', asc: '---', bmi: '---' });
    //const [open, setOpen] = React.useState(false);


    const res = (props) => {
        let x = 0;
        let y = 1.93303;
        let z = 0;
        let db11 = 0;
        //let age = 0;
        let bmi = (parseInt(props.weight) / (parseInt(props.height)
            * parseInt(props.height) / 10000));

        function ln(i) {
            return Math.log(i);
        }

        let ascvd1;
        let Risk_factors = 0.1;
        let Risk_factors1 = 0.1;
        if (props.sex === 'Male') {
            if (props.sbp)
                y = 1.99881;
            if (props.cigarette)
                z = 0.52873;
            if (props.diabetes)
                db11 = 0.69154;
            // if (!(parseInt(props.age) < 20 || parseInt(props.age) > 74))
            //     age = parseInt(props.age);
            Risk_factors = (ln(parseInt(props.age)) * 3.06117) +
                (ln(parseInt(props.cholesterol)) * 1.12370) -
                (ln(parseInt(props.hdl)) * 0.93263)
                + (ln(parseInt(props.sbp)) * y) + z + db11 - 23.9802;
            ascvd1 = 100 * (1 - Math.pow(0.88936, Math.exp(Risk_factors)));
        } else {

            y = 2.76157;
            z = 0;
            db11 = 0;
            if (parseInt(props.hypertension))
                y = 2.82263;
            if (props.cigarette)
                z = 0.52873;
            if (props.diabetes)
                db11 = 0.69154;
            Risk_factors1 = (ln(parseInt(props.age)) * 2.32888) +
                (ln(parseInt(props.cholesterol)) * 1.20904) -
                (ln(parseInt(props.hdl)) * 0.70833)
                + (ln(parseInt(props.sbp)) * y) + z + db11 - 26.1931;
            ascvd1 = 100 * (1 - Math.pow(0.95012, Math.exp(Risk_factors1)));
            //ascvd1 = Risk_factors1;
        }
        // if (parseInt(props.tg) >= 150) {
        //     if (parseInt(props.tg) < 500)
        //         document.getElementById("TG").style.backgroundColor = "lightblue";
        //     else if (parseInt(props.tg) < 1000)
        //         document.getElementById("TG").style.backgroundColor = "lightgreen";
        //     else
        //         document.getElementById("TG").style.backgroundColor = "red";
        // }
        if (props.acvd)
            x = 20;
        // else if (document.getElementById("2th").checked)
        //     x = 6;
        else if (props.diabetes && ascvd1 >= 20)
            x = 5;
        else if (props.diabetes)
            x = 1;
        else if (props.ldlb)
            x = 2;
        else if (ascvd1 >= 20) {
            x = 3;
        } else if (ascvd1 < 20 && ascvd1 >= 10) {
            x = 4;
        }
        let results = { res: '---', res1: '---', res2: '---', res3: '---', res4: '---', asc: '---', bmi: '---', alert1: '---' };
        if (x === 20 && parseInt(props.age) < 75) {
            Object.assign(results, { res: "high intensity statin" });
            Object.assign(results, { res1: "Atorvastatin 40-80 mg/day" });
            Object.assign(results, { res2: "Rosuvastatin 20-40 mg/day" });
            Object.assign(results, { res3: "---" });
            Object.assign(results, { res4: "---" });
            Object.assign(results, { alert1: "High intensity - LDL goal<70 mg/dL" });
            Object.assign(results, { bmi: "BMI: " + bmi.toFixed(2) });
            Object.assign(results, { asc: "ASCVD: --%" });

        } else if (x === 20 && parseInt(props.age) > 75) {
            Object.assign(results, { res: "maximum tolarated statin" });
            Object.assign(results, { res1: "Atorvastatin 10-80 mg/day" });
            Object.assign(results, { res2: "Rosuvastatin 5-40 mg/day" });
            Object.assign(results, { res3: "Simvastatin 20-40 mg/day" });
            Object.assign(results, { res4: "Lovastatin 40-80 mg/day" });
            Object.assign(results, { alert1: "High intensity - LDL goal<70 mg/dL" });
            Object.assign(results, { bmi: "BMI: " + bmi.toFixed(2) });
            Object.assign(results, { asc: "ASCVD: --%" });
        } else if (x === 1 && parseInt(props.age) > 40) {
            Object.assign(results, { res: "moderate intensity statin" });
            Object.assign(results, { res1: "Atorvastatin 10-20 mg/day" });
            Object.assign(results, { res2: "Rosuvastatin 5-10 mg/day" });
            Object.assign(results, { res3: "Simvastatin 20-40 mg/day" });
            Object.assign(results, { res4: "Lovastatin 40-80 mg/day" });
            Object.assign(results, { alert1: "Modarate intensity - LDL goal<100 mg/dL" });
            Object.assign(results, { bmi: "BMI: " + bmi.toFixed(2) });
            Object.assign(results, { asc: "ASCVD: " + ascvd1.toFixed(2) + "%" });
        } else if (x === 2 && parseInt(props.age) > 40) {
            Object.assign(results, { res: "high intensity statin" });
            Object.assign(results, { res1: "Atorvastatin 40-80 mg/day" });
            Object.assign(results, { res2: "Rosuvastatin 20-40 mg/day" });
            Object.assign(results, { res3: "---" });
            Object.assign(results, { res4: "---" });
            Object.assign(results, { alert1: "High intensity - LDL goal<100 mg/dL" });
            Object.assign(results, { bmi: "BMI: " + bmi.toFixed(2) });
            Object.assign(results, { asc: "ASCVD: " + ascvd1.toFixed(2) + "%" });
        } else if (x === 2 && parseInt(props.age) > 40 && parseInt(props.age) < 75) {
            Object.assign(results, { res: "high intensity statin" });
            Object.assign(results, { res1: "Atorvastatin 40-80 mg/day" });
            Object.assign(results, { res2: "Rosuvastatin 20-40 mg/day" });
            Object.assign(results, { res3: "---" });
            Object.assign(results, { res4: "---" });
            Object.assign(results, { alert1: "High intensity - LDL goal<100 mg/dL" });
            Object.assign(results, { bmi: "BMI: " + bmi.toFixed(2) });
            Object.assign(results, { asc: "ASCVD: " + ascvd1.toFixed(2) + "%" });
        } else if (x === 3 && parseInt(props.age) > 40 && parseInt(props.age) < 75) {
            Object.assign(results, { res: "high intensity statin" });
            Object.assign(results, { res1: "Atorvastatin 40-80 mg/day" });
            Object.assign(results, { res2: "Rosuvastatin 20-40 mg/day" });
            Object.assign(results, { res3: "---" });
            Object.assign(results, { res4: "---" });
            Object.assign(results, { alert1: "High intensity - LDL goal<100 mg/dL" });
            Object.assign(results, { bmi: "BMI: " + bmi.toFixed(2) });
            Object.assign(results, { asc: "ASCVD: " + ascvd1.toFixed(2) + "%" });
        } else if (x === 4 && parseInt(props.age) > 40 && parseInt(props.age) < 75) {
            Object.assign(results, { res: "moderate intensity statin" });
            Object.assign(results, { res1: "Atorvastatin 10-20 mg/day" });
            Object.assign(results, { res2: "Rosuvastatin 5-10 mg/day" });
            Object.assign(results, { res3: "Simvastatin 20-40 mg/day" });
            Object.assign(results, { res4: "Lovastatin 40-80 mg/day" });
            Object.assign(results, { alert1: "Modarate intensity - LDL goal<100 mg/dL" });
            Object.assign(results, { bmi: "BMI: " + bmi.toFixed(2) });
            Object.assign(results, { asc: "ASCVD: " + ascvd1.toFixed(2) + "%" });
        } else if (x === 5 && parseInt(props.age) > 40 && parseInt(props.age) < 75) {
            Object.assign(results, { res: "high intensity statin" });
            Object.assign(results, { res1: "Atorvastatin 40-80 mg/day" });
            Object.assign(results, { res2: "Rosuvastatin 20-40 mg/day" });
            Object.assign(results, { res3: "---" });
            Object.assign(results, { res4: "---" });
            Object.assign(results, { alert1: "High intensity - LDL goal<100 mg/dL" });
            Object.assign(results, { bmi: "BMI: " + bmi.toFixed(2) });
            Object.assign(results, { asc: "ASCVD: " + ascvd1.toFixed(2) + "%" });
        } else if (x === 6) {
            Object.assign(results, { res: "high intensity statin" });
            Object.assign(results, { res1: "Atorvastatin 40-80 mg/day" });
            Object.assign(results, { res2: "Rosuvastatin 20-40 mg/day" });
            Object.assign(results, { res3: "---" });
            Object.assign(results, { res4: "---" });
            Object.assign(results, { alert1: "High intensity - LDL goal<40 mg/dL" });
            Object.assign(results, { bmi: "BMI: " + bmi.toFixed(2) });
            Object.assign(results, { asc: "ASCVD: " + ascvd1.toFixed(2) + "%" });
        } else {
            Object.assign(results, { res: "no prescription" });
            Object.assign(results, { alert1: "no prescription" });
            Object.assign(results, { res1: "---" });
            Object.assign(results, { res2: "---" });
            Object.assign(results, { res3: "---" });
            Object.assign(results, { res4: "---" });
            Object.assign(results, { asc: "ASCVD: " + ascvd1.toFixed(2) + "%" });
            Object.assign(results, { bmi: "BMI: " + bmi.toFixed(2) });
        }
        // x = 0;
        // bmi = 0;
        return results;
    }
    const handleCLick = () => {
        setCalculated(res(props));
    }

    return (
        <div>
            <div align="left"><Button id="btnCalc"
                onClick={() => {
                    handleCLick();
                    //setOpen(true);
                }}
                variant="outlined">Calculate</Button>
            </div>
            {/* open && <ModalEnd open={true} /> */}
            {/*<ModalEnd open={open}/>*/}
            {/*{console.log("open")}*/}
            <Typography variant="subtitle1" gutterBottom align="left">
                <br />
                {/* <b>
                    <div id="res"> {calculated.res}</div>
                </b> */}
                <div><b id="asc">{calculated.asc}</b></div>
                <b>
                    <div id="alert1"> {calculated.alert1}</div>
                </b>
                <Typography color={calculated.asc !== "---" ? `red` : ``} fontWeight="bold" mt={calculated.asc !== "---" ? `1rem` : ``}>{calculated.asc !== "---" ? `Recommend` : `---`}</Typography>
                <b>
                    <div id="res1"> {calculated.res1}</div>
                </b>
                <b>
                    <div id="res2"> {calculated.res2}</div>
                </b>
                <b>
                    <div id="res3"> {calculated.res3}</div>
                </b>
                <b>
                    <div id="res4"> {calculated.res4}</div>
                </b>

                <div><b id="bmi">{calculated.bmi}</b></div>
            </Typography>
        </div>
    );
};

export default Calculation;